import { PostHogProvider } from "posthog-js/react";
import { StrictMode, Suspense } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { createBrowserRouter, RouteObject, RouterProvider } from "react-router-dom";
import {
  createStaticRouter,
  StaticRouterProvider,
} from "react-router-dom/server";
import { LoaderLogo } from "./components/Loader/LoaderLogo";
import routes from "./routes";
import routes_ssr from "./routes_ssr"; // массив RouteObject[]

const ssrData = (window as any).__SSR_DATA__;
const isDev = process.env.NODE_ENV === "development";

const posthogApiKey = "phc_KBp3Os6czJTZYmROYtVhDxq3nkdeqqD1SBRZJFcOj3J";
const posthogHost = "https://eu.i.posthog.com";

const AppSSR = () => {
  const router = createStaticRouter(routes_ssr, ssrData.context);
  return (
    <StrictMode>
      <PostHogProvider
        apiKey={posthogApiKey || ""}
        options={{
          api_host: posthogHost,
          capture_exceptions: true,
          debug: process.env.NODE_ENV === "development",
        }}
      >
        <Suspense fallback={<LoaderLogo isLoading />}>
          <StaticRouterProvider router={router} context={ssrData.context} />
        </Suspense>
      </PostHogProvider>
    </StrictMode>
  );
};

const AppDev = () => {
  const router = createBrowserRouter(routes as RouteObject[], {
    future: {
      v7_relativeSplatPath: true,
    },
  });
  return (
    <StrictMode>
      <PostHogProvider
        apiKey={posthogApiKey || ""}
        options={{
          api_host: posthogHost,
          capture_exceptions: true,
          debug: process.env.NODE_ENV === "development",
        }}
      >
        <Suspense fallback={<LoaderLogo isLoading />}>
          <RouterProvider router={router} />
        </Suspense>
      </PostHogProvider>
    </StrictMode>
  );
};

const rootElement = document.getElementById("root")!;
if (ssrData) {
  hydrateRoot(rootElement, <AppSSR />);
} else if (isDev) {
  const root = createRoot(rootElement);
  root.render(<AppDev />);
}